<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box"><p style="color: white" > Aguarde... </p></ngx-spinner>